import axios from "axios";

const API = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/notifications`
});

// GET NOTIFICATIONS FOR EMPLOYEE
export const getNotifications = async (employeeId) => {
    const response = await API.get("/", {
        params: { employee_id: employeeId }
    });

    return response.data;
};

// GET UNREAD COUNT
export const getUnreadCount = async (employeeId) => {
    const response = await API.get("/unread-count", {
        params: { employee_id: employeeId }
    });

    return response.data.count;
};

// MARK SINGLE NOTIFICATION AS READ
export const markNotificationRead = async (notificationId) => {
    const response = await API.patch(`/${notificationId}/read`);

    return response.data;
};

// MARK ALL NOTIFICATIONS AS READ
export const markAllNotificationsRead = async (employeeId) => {
    const response = await API.patch("/read-all", null, {
        params: { employee_id: employeeId }
    });

    return response.data;
};

export default API;
